/**
 * @generated SignedSource<<1daa029aadfdb7c4a25929577eeade13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunicationTemplateCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCommunicationTemplateTPayload",
        "kind": "LinkedField",
        "name": "createCommunicationTemplateT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CommunicationTemplateT",
            "kind": "LinkedField",
            "name": "communicationTemplateT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunicationTemplateCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateCommunicationTemplateTPayload",
        "kind": "LinkedField",
        "name": "createCommunicationTemplateT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CommunicationTemplateT",
            "kind": "LinkedField",
            "name": "communicationTemplateT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be0ef1c4899a59cfcb627411347ab385",
    "id": null,
    "metadata": {},
    "name": "CommunicationTemplateCreateMutation",
    "operationKind": "mutation",
    "text": "mutation CommunicationTemplateCreateMutation(\n  $input: CreateCommunicationTemplateTInput!\n) {\n  createCommunicationTemplateT(input: $input) {\n    communicationTemplateT {\n      ctId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "00e1c6f155dba8dc620174cf5a8ee165";

module.exports = node;
